export enum ProductSelection {
    None = 0,
    Sms = 1,
    Video = 2,
    RecordView = 3,
    MessagePractice = 4,
}
